<template>
    <div class="partner-area bg-color-f9f9f9 ptb-100">
        <div class="container">
            <div class="partner-slider-six">
                <carousel
                    :autoplay="5000"
                    :settings='settings' 
                    :breakpoints='breakpoints'
                >
                    <Slide v-for="slide in carouselItems" :key="slide.id">
                        <div class="partner-item">
                            <img :src="slide.image" alt="Image">
                        </div>
                    </Slide>

                    <template #addons>
                    </template>
                </carousel>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { Carousel, Slide  } from 'vue3-carousel';

import 'vue3-carousel/dist/carousel.css';

export default defineComponent ({
    name: 'Partner',
    components: {
        Carousel,
        Slide,
    },
    data: () => ({
        settings: {
            itemsToShow: 1,
            snapAlign: 'center',
        },
        carouselItems: [
            {
                id: 1,
                image: require('../../assets/images/partner/partner-11.png'),
            },
            {
                id: 2,
                image: require('../../assets/images/partner/partner-12.png'),
            },
            {
                id: 3,
                image: require('../../assets/images/partner/partner-13.png'),
            },
            {
                id: 4,
                image: require('../../assets/images/partner/partner-14.png'),
            },
            {
                id: 5,
                image: require('../../assets/images/partner/partner-11.png'),
            },
            {
                id: 6,
                image: require('../../assets/images/partner/partner-12.png'),
            },
            {
                id: 7,
                image: require('../../assets/images/partner/partner-13.png'),
            },
            {
                id: 8,
                image: require('../../assets/images/partner/partner-14.png'),
            },
        ],
        breakpoints: {
            0: {
                itemsToShow: 1,
                snapAlign: 'center',
			},
            576: {
                itemsToShow: 2,
                snapAlign: 'center',
            },
            768: {
                itemsToShow: 2,
                snapAlign: 'center',
            },
            992: {
                itemsToShow: 3,
                snapAlign: 'center',
            },
            1200: {
                itemsToShow: 4,
                snapAlign: 'center',
            },
        },
    }),
})
</script>